/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { isMobileOnly } from 'react-device-detect';

import productColor from 'components/styles';
import AppNotificationPanel from 'components/molecules/AppNotificationPanel';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import PrimaryButton from 'components/atoms/Button';
import BodyText from 'components/atoms/BodyText';
import ClickableLink from 'components/atoms/ClickableLink';
import PhotoFrame from 'components/molecules/PhotoFrame';
import usePhotoPath from 'hooks/usePhotoPath';

const styles = {
  background: css({
    padding: '20px',
    backgroundColor: productColor.primaryM90,
  }),
  avatar: css({
    width: '48px',
  }),
};

const StaffSettingPanel: React.FC<{
  staffName: string;
  logoutAction: () => void;
}> = ({ staffName, logoutAction }) => {
  const { myPhotoPath } = usePhotoPath();
  // 端末設定のメニュー権限（PrivateRoute がログイン時に保存）
  const showShopSpecify = isMobileOnly
    && sessionStorage.getItem('mobileMasterShopSpecify') === '1';
  return (
    <AppNotificationPanel>
      <div css={styles.background}>
        <FlexBox direction="column">
          <FlexBoxItem>
            <PhotoFrame src={myPhotoPath} size="90px" isCircle={true} onErrorIconColor="black" />
          </FlexBoxItem>
          <FlexBoxItem>
            <BodyText>{staffName}</BodyText>
          </FlexBoxItem>
        </FlexBox>
      </div>

      {isMobileOnly ? (
        <FlexBox direction="column" customStyle={css({ padding: '12px' })}>
          <FlexBoxItem width="100%">
            <ClickableLink to="/personalSetting" padding="0">
              <PrimaryButton text="マイページ" fullwidth={true} />
            </ClickableLink>
          </FlexBoxItem>
          {showShopSpecify && (
            <FlexBoxItem width="100%" margin="8px 0 0 0">
              <ClickableLink to="/masterShopSpecify" padding="0">
                <PrimaryButton text="端末設定" fullwidth={true} />
              </ClickableLink>
            </FlexBoxItem>
          )}
          <FlexBoxItem width="100%" margin="8px 0 0 0">
            <PrimaryButton
              text="ログアウト"
              ghost={true}
              fullwidth={true}
              onClick={logoutAction}
            />
          </FlexBoxItem>
        </FlexBox>
      ) : (
        <FlexBox customStyle={css({ padding: '12px' })}>
          <FlexBoxItem>
            <ClickableLink
              to="/personalSetting" // TODO リンク先は仮
              padding="0"
            >
              <PrimaryButton text="マイページ" />
            </ClickableLink>
          </FlexBoxItem>
          <FlexBoxItem marginLeft="auto">
            <PrimaryButton
              text="ログアウト"
              ghost={true}
              onClick={logoutAction}
            />
          </FlexBoxItem>
        </FlexBox>
      )}
    </AppNotificationPanel>
  );
};

export default StaffSettingPanel;
